// Lightweight reCAPTCHA v3 loader (no extra dependency).
// Graceful degradation: if REACT_APP_RECAPTCHA_SITE_KEY is missing, executeRecaptcha() resolves to null.

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let scriptPromise = null;

function loadScript() {
  if (!SITE_KEY) return Promise.resolve(false);
  if (typeof window === "undefined") return Promise.resolve(false);
  if (window.grecaptcha && window.grecaptcha.execute) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve) => {
    const existing = document.querySelector('script[data-recaptcha="1"]');
    if (existing) {
      existing.addEventListener("load", () => resolve(true));
      return;
    }
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    s.async = true;
    s.defer = true;
    s.dataset.recaptcha = "1";
    s.onload = () => resolve(true);
    s.onerror = () => {
      // eslint-disable-next-line no-console
      console.warn("[reCAPTCHA] failed to load");
      resolve(false);
    };
    document.head.appendChild(s);
  });
  return scriptPromise;
}

export function preloadRecaptcha() {
  loadScript();
}

export async function executeRecaptcha(action = "enquiry_submit") {
  if (!SITE_KEY) return null;
  const loaded = await loadScript();
  if (!loaded || !window.grecaptcha) return null;
  return new Promise((resolve) => {
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(SITE_KEY, { action });
        resolve(token);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn("[reCAPTCHA] execute failed", err);
        resolve(null);
      }
    });
  });
}

export const isRecaptchaEnabled = () => Boolean(SITE_KEY);
